export default __webpack_public_path__ + "static/media/flower.16d4040c.png";